import clsx from 'clsx'

import { LiveIcon } from 'src/components'

import { LiveIconBox } from './liveBadge.styles'
import { LiveBadgeProps } from './liveBadge.types'

const LiveBadge = ({ className, invert = true }: LiveBadgeProps) => {
  return (
    <LiveIconBox
      invert={invert}
      className={clsx(
        '_position-absolute brand _px-1 _d-flex _align-items-center _justify-content-center _rounded _font-weight-bold',
        className
      )}
    >
      <picture
        className="_d-flex _align-items-center _justify-content-center _mr-1"
        data-test="live-badge"
      >
        <LiveIcon />
      </picture>
      LIVE
    </LiveIconBox>
  )
}

export default LiveBadge
